const borderRadius = {
  sm: `3px`,
  md: `6px`,
  round: `50%`,
  pill: `9999px`,
}

export default borderRadius
